import { SaveOutlined } from "@ant-design/icons"
import { Button } from "antd"

export const ModalFooterButtons = ({ disabled, modalClose, loadingButton, formId }) => {

    return (
        <div key="footer_buttons" className="footer-modal-buttons">
            <Button
            className="mr10"
                form={formId}
                loading={loadingButton}
                icon={<SaveOutlined />}
                type="primary"
                htmlType="submit"
                key="submit"
                disabled={disabled}
            >
                Salva</Button>

            <Button key="close" onClick={modalClose}>Chiudi</Button>

        </div>
    )

}